module.exports = __webpack_public_path__ + "img/personal.6c2329da.png";